/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://azysmorob6.execute-api.ap-southeast-1.amazonaws.com/prod",
            "region": "ap-southeast-1"
        }
    ],
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_jqIs9lVLm",
    "aws_user_pools_web_client_id": "3o8eeqa43jo2ui5ev6hrm3flkv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "10",
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "loyalty-service-centre-site-prod",
    "aws_content_delivery_bucket_region": "ap-southeast-1",
    "aws_content_delivery_url": "https://d1241ivzxvx5fd.cloudfront.net",
    "aws_project_stage": "prod",
    "aws_project_account_number": "672909237265",
    "aws_custom_resources": {
        "cfnResources": {
            "env": "prod",
            "SomeOverPermissiveFunctionRoleARN": "arn:aws:iam::672909237265:role/amplify-lscsite-prod-2073-SomeOverPermissiveFuncti-14204IJQ3549E"
        },
        "cdkResources": {
            "userPoolArn": "arn:aws:cognito-idp:ap-southeast-1:672909237265:userpool/ap-southeast-1_jqIs9lVLm",
            "iamRoleArn": "arn:aws:iam::672909237265:role/amplify-lscsite-prod-2073-AnotherOverlyPermissiveR-G1AUT3I78TYK",
            "envParameter": "prod"
        }
    },
    "aws_chalice_environment": {
        "CONTENT_UPLOAD_ALLOWED_EXT": "pdf,png,jpg,jpeg,gif,webp,mp4"
    },
    "aws_chalice_api_resources": {
        "rest_api": {
            "name": "rest_api",
            "resource_type": "rest_api",
            "rest_api_id": "zio5ja2kv3",
            "rest_api_url": "https://zio5ja2kv3.execute-api.ap-southeast-1.amazonaws.com/api/"
        },
        "api_gateway_custom_domain": {
            "name": "api_gateway_custom_domain",
            "resource_type": "domain_name",
            "hosted_zone_id": "Z2FDTNDATAQYW2",
            "alias_domain_name": "d2t7kkxdj0mfvo.cloudfront.net",
            "certificate_arn": "arn:aws:acm:us-east-1:672909237265:certificate/8aea4fe5-9645-435f-afe1-3fa7499cbdd4",
            "security_policy": "TLS_1_2",
            "domain_name": "lsc-api.abrholdings.ltd",
            "api_mapping": [
                {
                    "key": "/"
                }
            ]
        },
        "websocket_api": {
            "name": "websocket_api",
            "resource_type": "websocket_api",
            "websocket_api_url": "wss://6ol6smu26h.execute-api.ap-southeast-1.amazonaws.com/api/",
            "websocket_api_id": "6ol6smu26h"
        },
        "websocket_api_custom_domain": {
            "name": "websocket_api_custom_domain",
            "resource_type": "domain_name",
            "hosted_zone_id": "ZL327KTPIQFUL",
            "alias_domain_name": "d-3q2y63jwa9.execute-api.ap-southeast-1.amazonaws.com",
            "certificate_arn": "arn:aws:acm:ap-southeast-1:672909237265:certificate/69fe448e-1f0c-43b8-842a-b36996747563",
            "security_policy": "TLS_1_2",
            "domain_name": "lsc-api-ws.abrholdings.ltd",
            "api_mapping": [
                {
                    "key": "/"
                }
            ]
        }
    }
};


export default awsmobile;
